module.exports = __webpack_public_path__ + "media/images/icons/chevron-left-d9f444c26cbae5528aef414459ecafe1.svg";